import { Show, useRecordContext } from 'react-admin';
import { BridgeShowTopBar } from '../../../helperComponents/BridgeShowTopBar';
import { JobShowHeader } from './components/JobShowHeader';
import { JobShowStats } from './components/JobShowStats';
import { JobLastRuns } from './components/JobLastRuns';
import { JobConfig } from './components/JobConfig';

const AdsJobsShowBody = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <>
      <BridgeShowTopBar backTo="/ads_jobs" backLabel="Jobs" crumb={`Google Ads Bridge / Jobs / ${record.id}`} />
      <JobShowHeader record={record} />
      <JobShowStats record={record} />
      <JobLastRuns record={record} />
      <JobConfig record={record} />
    </>
  );
};

export const AdsJobsShow = (props) => {
  return (
    <Show {...props} title=" " actions={false} component="div">
      <AdsJobsShowBody />
    </Show>
  );
};
